import React from "react";
import {Link} from "react-scroll";

const RedirectMenu: React.FC<{ content?: Map<string, string | null>, defaultTemplate?: boolean  }> = ({ content, defaultTemplate }) => {
    return (
        <div className={"div-section"} style={{marginTop: '48px'}}>
            <div style={{height: '40px'}}>
                <span className="title-section">目次</span>
            </div>

            <div className={"border-title"}>
                <div className={"underline-title"}></div>
            </div>


            <div className="flex flex-wrap mt-4 text-blue-600">
                {
                    (content?.has("SUMMARY_WITH_CHART") || defaultTemplate) &&
                    <>
                        <span>
                            <Link to="general" smooth={true} duration={200} offset={-56} style={{cursor: 'pointer', color: '#3386CC'}}>
                                {
                                    content?.has("SUMMARY_WITH_CHART") ? content.get("SUMMARY_WITH_CHART") != null ? content.get("SUMMARY_WITH_CHART") : 'サマリ' : 'サマリ'
                                }
                            </Link>
                        </span>
                        <span className="border-padding-15">|</span>
                    </>
                }

                {
                    (content?.has("HIGH_SKILLS") || defaultTemplate) &&
                    <>
                        <span>
                                    <Link to="highSkills" smooth={true} duration={200} offset={-56} style={{cursor: 'pointer', color: '#3386CC'}}>
                                        {
                                            content?.has("HIGH_SKILLS") ? content.get("HIGH_SKILLS") != null ? content.get("HIGH_SKILLS") : '偏差値が高かったスキル' : '偏差値が高かったスキル'
                                        }
                                    </Link>
                                </span>
                        <span className="border-padding-15">|</span>
                    </>
                }
                {
                    (content?.has("LOW_SKILLS") || defaultTemplate) &&
                    <>
                        <span>
                                    <Link to="lowSkills" smooth={true} duration={200} offset={-56} style={{cursor: 'pointer', color: '#3386CC'}}>
                                        {
                                            content?.has("LOW_SKILLS") ? content.get("LOW_SKILLS") != null ? content.get("LOW_SKILLS") : '偏差値が低かったスキル' : '偏差値が低かったスキル'
                                        }
                                    </Link>
                                </span>
                        <span className="border-padding-15">|</span>
                    </>
                }
                {
                    (content?.has("COMPARISON") || defaultTemplate) &&
                    <>
                        <span>
                                    <Link to="comparison" smooth={true} duration={200} offset={-56} style={{cursor: 'pointer', color: '#3386CC'}}>
                                        {
                                            content?.has("COMPARISON") ? content.get("COMPARISON") != null ? content.get("COMPARISON") : '3年前と現在の比較' : '3年前と現在の比較'
                                        }
                                    </Link>
                                </span>
                        <span className="border-padding-15">|</span>
                    </>
                }
                {
                    (content?.has("SUMMARY") || defaultTemplate) &&
                    <>
                        <span>
                                    <Link to="summary" smooth={true} duration={200} offset={-56} style={{cursor: 'pointer', color: '#3386CC'}}>
                                        {
                                            content?.has("SUMMARY") ? content.get("SUMMARY") != null ? content.get("SUMMARY") : '総括' : '総括'
                                        }
                                    </Link>
                                </span>
                        <span className="border-padding-15">|</span>
                    </>
                }
                {
                    (content?.has("RECOMMENDED") || defaultTemplate) &&
                    <>
                        <span>
                                    <Link to="recommended" smooth={true} duration={200} offset={-56} style={{cursor: 'pointer', color: '#3386CC'}}>
                                        {
                                            content?.has("RECOMMENDED") ? content.get("RECOMMENDED") != null ? content.get("RECOMMENDED") : 'おすすめコンテンツ' : 'おすすめコンテンツ'
                                        }
                                    </Link>
                                </span>
                    </>
                }
            </div>
        </div>
    );
};

export default RedirectMenu;
